import React from 'react';
import PropTypes from 'prop-types';
import { Subhead } from '@xo-union/tk-ui-typography';
import BrandLogo from '@xo-union/component-brand-logo';
import styles from './mobile-bumper.scss';

const MobileBumper = props => (
  <div className={styles.container}>
    <a href={props.weddingPlanningUrl} className={`content link ${styles.backButton}`}>
      Back
    </a>

    <div className={styles.innerContainer}>
      <Subhead className={styles.title}>
        <a href="https://theknot.app.link/hPkhZnNCnV">Download the app!</a>
      </Subhead>
      <div className={styles.body}>
        Our Guest List Manager tool isn&apos;t supported by mobile browsers. Please download our{' '}
        <a href="https://theknot.app.link/hPkhZnNCnV">Planner app</a> to manage your guest list from a mobile device. In
        the meantime, check out our other great <a href={props.weddingPlanningUrl}>wedding planning tools</a>.
      </div>
      <BrandLogo className={styles.logo} name="theknot" color="primary" />
    </div>
  </div>
);

MobileBumper.propTypes = {
  weddingPlanningUrl: PropTypes.string.isRequired,
};

export default MobileBumper;
